import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import { Link } from 'react-router-dom';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import PrintIcon from '@material-ui/icons/Print';
import { Formik, Form } from 'formik';
import Modal_Frame from "../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../hooks/UseFetchData";
import BiztranControls from "../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../biztran_controls_formik/BiztranControlsFormik";
import Data_Grid from "../biztran_controls/DataGrid";
import CreateMfgBatch from "./CreateMfgBatch";
import PrintQRCode from "./PrintQRCode";
import CreateSerialNumber from "./CreateSerialNumber";
//import AddExpenseSheet from "./AddExpenseSheet";
const todate = new Date()
//const fromdate = todate.getFullYear() + todate.getMonth() + '/01';
const fromdate = todate.getFullYear() - 1 + '/04/01';


const Cecertificate = () => {

  const [FromDate, setFromDate] = useState(fromdate);
  const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [defaultToDate, setdefaultToDate] = useState(todate);
  const [isOpen, setOpen] = useState(false);
  const [isPrintOpen, setPrintOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Count, setCount] = useState();
  const [ModelName, setModelName] = useState('');
  const [SerialNumber, setSerialNumber] = useState('');
  const [Statuscmb, setStatuscmb] = useState([]);
  const [MfgBatchID, setMfgBatchID] = useState('');
  const [MfgBatchNo, setMfgBatchNo] = useState('');
  const [MfgDate, setMfgDate] = useState('');
  const [MfgQty, setMfgQty] = useState('');
  const [Remarks, setRemarks] = useState('');
  const [CreatedByID, setCreatedByID] = useState('');
  const [CreatedOn, setCreatedOn] = useState('');
  const [ModifiedByID, setModifiedByID] = useState('');
  const [ModifiedOn, setModifiedOn] = useState('');
  const [ModelCode, setModelCode] = useState('');
  const [response, fetchData] = UseFetchData();


  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }

  const openModal = (row) => {
    setEditOpen(true);
    setMfgBatchID(row.id);
  };

  const handleOpenModal = () => {
    setOpen(true);
    setMfgBatchID('');
  };

  const handleOpenPrint = () => {
    setPrintOpen(true);
    setMfgBatchID('');
  };

  const PopulatebData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    bodyFormData.append("MfgBatchID", MfgBatchID);
    bodyFormData.append("MfgBatchNo", MfgBatchNo);
    bodyFormData.append("MfgDate", MfgDate);
    bodyFormData.append("Remarks", Remarks);
    bodyFormData.append("MfgQty", MfgQty);
    bodyFormData.append("SerialNumber", SerialNumber);
    bodyFormData.append("ModelName", ModelName);
    bodyFormData.append("ModelCode", ModelCode);
    bodyFormData.append("CreatedByID", CreatedByID);
    bodyFormData.append("CreatedOn", CreatedOn);
    bodyFormData.append("ModifiedByID", ModifiedByID);
    bodyFormData.append("ModifiedOn", ModifiedOn);
    fetchData("MfgBatch/List", bodyFormData);
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: "Select",
        //renderCell: (params) => (<strong> <Link to={{ pathname: "/SerialNumberList/UpdateSerialNumberView", state: { MfgBatchID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 120,
      },
      {
        field: "MfgBatchNo",
        headerName: "Mfg Batch No",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 180,
      },
      {
        field: "MfgDate",
        headerName: "Mfg Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ModelCode",
        headerName: "Model No",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "ModelName",
        headerName: "Model Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 170,
      },
      {
        field: "MfgQty",
        headerName: "Mfg Qty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "SerialNumber",
        headerName: "Serial No ",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "Remarks",
        headerName: "Remarks",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },

      {
        field: "CreatedByID",
        headerName: "Created By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      {
        field: "CreatedOn",
        headerName: "Created On ",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 160,
      },
      // {
      //   field: "ModifiedByID",
      //   headerName: "Modified By",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 160,
      // },
      // {
      //   field: "ModifiedOn",
      //   headerName: "Modified On",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 180,
      // },

    ];
    setColumns(gridCols);
    setRows(response);
    setCount(response.length);
  }, [response]
  );

  useEffect(() => {
    PopulatebData();
  }, [])

  return (
    <div>
      {/* <Paper elevation={0}> */}
      <Grid container="row">
        <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
          <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
            <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setFromDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onFromClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultfromDate}
            >
            </DatePickerInput>
          </div>
        </Grid>
        <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
          <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
            <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
            <DatePickerInput
              onChange={(jsDate, dateString) => setToDate(dateString)}
              locale="en"
              displayFormat="DD/MMM/YYYY"
              className='my-react-component'
              onClear={() => { onToClear(); }}
              showOnInputClick
              maxDate={new Date()}
              returnFormat="YYYY/MM/DD"
              defaultValue={defaultToDate}
            >
            </DatePickerInput>
          </div>
        </Grid>
      </Grid>
      <br />
      <Grid container direction="row" marginTop={10} style={{ paddingTop: -4 }}>
        <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
          <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
              <BiztranControls.Input
                label="Model Name"
                id="ModelName"
                onChange={(e) => setModelName(e.target.value)}
              />
            </div>
          </div>
        </Grid>
        <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
          <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
              <BiztranControls.Input
                label="Serial Number"
                id="SerialNumber"
                onChange={(e) => setSerialNumber(e.target.value)}
              />
            </div>
          </div>
        </Grid>
        <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 20 }}>
          <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
        </div>
        {/* <Grid item xs={2}>
          <div style={{ width: "60%", marginLeft: 9, marginTop: 30 }} >
            <label
              htmlFor={"ModelID"}
              style={{
                display: "block",
                width: "100%",
              }}
            >
              {"Model Name"}
            </label>
          </div>

        </Grid> */}


        {/* <Grid item xs={3} >
          <div style={{ width: "110%", marginLeft: -109, marginTop: 20 }} >
            <div style={{ float: "left", marginTop: 0, width: "80%" }}>
              <BiztranControls.Input
                autoFocus="autofocus"
                control="input"
                type="text"
                name="ModelName"

                //ref={ref}
                value={ModelName}
                //options={ASIcmb}                   
                onChange={(e) => {
                  setModelName(e.target.value)
                  //handleChange()
                }}
              />
            </div>
          </div>
        </Grid> */}

        {/* <Grid item xs={2}>
          <div style={{ width: "125%", marginLeft: -189, marginTop: 30 }} >
            <label
              htmlFor={"SerialNumber"}
              style={{
                display: "block",
                width: "100%",
              }}
            >
              {"Serial Number"}
            </label>
          </div>

        </Grid> */}


        {/* <Grid item xs={3} >
          <div style={{ width: "90%", marginLeft: -289, marginTop: 20 }} >
            <div style={{ float: "left", marginTop: 0, width: "40%" }}>
              <BiztranControls.Input
                autoFocus="autofocus"
                control="input"
                type="text"
                name="SerialNumber"

                //ref={ref}
                value={SerialNumber}
                //options={ASIcmb}                   
                onChange={(e) => {
                  setSerialNumber(e.target.value)
                  //handleChange()
                }}
              />
            </div>
          </div>
        </Grid> */}

        <Grid style={{ marginTop: 8 }} >
          {/* <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: -380 }}>
            <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
          </div> */}

          <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
            <div style={{ float: "left", marginTop: 0, width: "30%" }}>
              <BiztranControls.Button
                text="SEARCH"
                startIcon={<SearchIcon />}
                style={{ marginTop: '1%' }}
                onClick={() => {
                  PopulatebData();
                }}
              />
            </div>
          </div>
          {/* <div style={{ float: "left",width: 16, marginTop: 0, marginLeft: 65 }}>
            <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
          </div> */}
          <div style={{ float: "left", marginTop: 0, marginLeft: 70, width: "30%" }}>
            <BiztranControls.Button
              text="ADD NEW"
              startIcon={<AddCircleOutlineIcon />}
              style={{ marginTop: '1%' }}
              onClick={() => {
                handleOpenModal();
              }}
            />
          </div>

        </Grid>
        <div style={{ float: "left", marginTop: 8, marginLeft: 70, width: "30%" }}>
          <BiztranControls.Button
            text="QR PRINT"
            startIcon={<PrintIcon />}
            style={{ marginTop: '1%' }}
            onClick={() => {
              handleOpenPrint();
            }}
          />
        </div>
      </Grid>


      <Modal_Frame
        title="Insert Serial Number"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateMfgBatch
          MfgBatchID={MfgBatchID}
          setOpen={setOpen}
          Mode="Insert"
          PopulatebData={PopulatebData}
        />
      </Modal_Frame>

      <Modal_Frame
        title="Update Serial Numbers"
        maxWidth="md"
        isOpen={editOpen}
        setOpen={setEditOpen}
      >
        <CreateMfgBatch
          MfgBatchID={MfgBatchID}
          setOpen={setEditOpen}
          Mode="Update"
          PopulatebData={PopulatebData}
        />
      </Modal_Frame>

      <Modal_Frame
        title="Print QR Code"
        maxWidth="md"
        isOpen={isPrintOpen}
        setOpen={setPrintOpen}
      >
        <PrintQRCode
          MfgBatchID={MfgBatchID}
          setOpen={setPrintOpen}
          Mode="Insert"
          PopulatebData={PopulatebData}
        />
      </Modal_Frame>

      <BiztranControls.DataGrid
        rowHeight={25}
        headerHeight={34}
        rows={rows}
        columns={columns}
        checkboxSelection={false}
        Width="107%"
        Height="410px"
      //hideFooter={true}
      />
      {/* </Paper> */}
    </div>
  )
}

export default Cecertificate;